import { useEffect, useState } from "react";

// how often a page's relative times ("5m ago", "how long it has run", "1 day
// left") are worked out again: they count minutes, so they are never more
// than half of one behind
const Tick = 30_000;

/** The time now, again every Tick while `ticking`; nothing runs while it is not. */
export function useNow(ticking = true): number {
  const [now, setNow] = useState(Date.now);
  useEffect(() => {
    if (!ticking) return;
    setNow(Date.now());
    const id = setInterval(() => setNow(Date.now()), Tick);
    return () => clearInterval(id);
  }, [ticking]);
  return now;
}
